<template>
  <v-container>
    <v-row>
      <v-col
              cols="12"
              sm="12"
              md="6"
            >
  <v-card>
    <v-card-title>
      <v-icon class="mr-2">mdi-information</v-icon>Go-France : jeu &amp; guide en ligne !
    </v-card-title>
    <v-divider/>
    <v-card-text class="text-justify">

      Go-France ce sont deux choses : un <span class="font-weight-bold">guide en ligne</span> permettant de trouver les points touristiques autour de vous et n'importe où en France.
      C'est aussi et surtout un <span class="font-weight-bold">jeu</span>, activé prochainement, où vous devez valider un maximum de localisations pour gagner des points !
    </v-card-text>
    <v-card-actions>
      <v-btn dark block color="teal darken-2" :to="{name:'Points'}"><v-icon>mdi-map-marker</v-icon>Voir les points touristiques</v-btn>
    </v-card-actions>
  </v-card>
  </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {

    data: () => ({
    }),
  }
</script>
